import * as React from 'react';

export function QuizActivitySVG(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M21 11H9a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Z"
                stroke="current"
                strokeWidth={1.5}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.45 19.05c0-.1 0-.3.1-.5l1.2-3.3c.2-.6.6-.9 1.2-.9.7 0 1.1.3 1.3.9l1.2 3.3c.1.2.1.4.1.5 0 .4-.3.8-.8.8s-.7-.2-.8-.7l-.1-.4h-1.7l-.1.3c-.1.5-.4.8-.8.8-.5-.1-.8-.4-.8-.8Zm3.1-1.5-.6-1.9-.5 1.9h1.1Z"
                fill="current"
            />
            <path
                d="M7 13H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7.9"
                stroke="current"
                strokeWidth={1.5}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx={9.075} cy={6.188} r={2.25} stroke="current" strokeWidth={1.5} />
            <path
                stroke="current"
                strokeWidth={1.4}
                strokeLinecap="round"
                d="m9.625 6.769 1.886 1.885"
            />
        </svg>
    );
}
